import React from 'react'

const Header = () => {
  return (
    <header className="text-center fixed z-50 w-screen p-3 px-4 md:p-6 md:px-16 bg-secondary">
      Header
    </header >
  )
}

export default Header